module.exports = __webpack_public_path__ + "media/images/ui__arrowUp--dark-fbecb145a68f6c3a1f4818297876db3d.png";